import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function deleteGroupMember(groupId) {
	return fetch(
		`${ENDPOINT_URL}/admingroup/deletegroup`,
		getFetchOptions({
			method: 'DELETE',
			body: JSON.stringify({
				groupId,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
